import React, {useEffect, useState} from "react";
import {Button, Input, Modal, Form, Radio, Popconfirm} from "antd";
import "./Consultants.scss"
import { openNotificationWithIcon } from "@frontend/src/utilities/notificationWithIcon";
import { consultantsService } from "@frontend/src/core/services/consultants_service";
import { DndProvider} from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Table } from 'antd';

const Consultants = ({
                          categories,
                          organizationId
                        }) => {
  const [showModal,setShowModal] = useState(false)
  const [consultantName,setConsultantName] = useState('')
  const [selectedConsultant,setSelectedConsultant] = useState(null)
  const [isCreating,setIsCreating] = useState(null)
  const [consultantsList,setConsultantsList] = useState([])
  const [isEditing,setIsEditing] = useState(null)
  const [isDeleting,setIsDeleting] = useState(null)
  const columnList = [{id:1, title:'Consultora', dataIndex:'name', ellipsis: true},
    {id:2, title: 'Usuarios asociados', dataIndex:'assigned_count', align: 'center', width: 90},
    {id:3, title: '', dataIndex:'', align: 'center', width: 90, fixed: 'right', render: (row) => consultantOptions(row)}]

  const consultantOptions = (category) => {
    return (
      <div>
        <span className="action-box" onClick={() => onChangeState(category)}>
          <i className="fa fa-pencil"></i>
        </span>
        <Popconfirm
          title="¿Estás seguro de eliminar la consultora?"
          onConfirm={() => destroyConsultant(category)}
          onCancel={() => {}}
          okText="Eliminar"
          cancelText="Cancelar"
        >
          <span className="action-box">
            <i className="fa fa-times"></i>
          </span>
        </Popconfirm>
      </div>
    )
  }

  const showConsultantModalList = () => {
    return (
      <Modal
        title={"Crear nueva consultora"}
        visible={showModal}
        onCancel={() => setShowModal(false)}
        onOk={() => selectedConsultant ? updateConsultant() : createConsultant()}
        cancelText={"Cancelar"}
        okText={"Guardar"}>
        <Form
          layout={'vertical'}>
          <Form.Item label={"Nombre de la consultora"}>
            <Input onChange={(e) => setConsultantName(e.target.value)}
                   value={selectedConsultant && !consultantName ? selectedConsultant.name : consultantName}/>
          </Form.Item>
        </Form>
      </Modal>
    )
  }

  const onChangeState = (category) => {
    setSelectedConsultant(category)
    setShowModal(true)
  }

  const createConsultant = () => {
    consultantsService
      .createNewConsultant({
          name:consultantName,
          organization_id:
          organizationId},
        (success) => {
          setIsCreating(success)
          openNotificationWithIcon(
            "success",
            "Consultora creada correctamente",
            ""
          );
        },
        (error) => console.error(error))
  }

  const destroyConsultant = (row) => {
    consultantsService
      .deleteConsultant(
        row.id,
        (success) => {
          setIsDeleting(success)
          openNotificationWithIcon(
            "success",
            "Consultora borrada correctamente",
            ""
          );
        },
        (error) => console.error(error))
  }

  const updateConsultant = () => {
    consultantsService
      .editConsultant({
          id: selectedConsultant.id,
          name: consultantName,
        },
        (success) => {
          setIsEditing(success)
          openNotificationWithIcon(
            "success",
            "Consultora actualizada correctamente",
            ""
          );
        },
        (error) => console.error(error))
  }

  const bringConsultants = () => {
    consultantsService.allConsultants(
      (success) => setConsultantsList(success),
      (error) => console.error(error))
  }


  useEffect(() => {
    if(showModal && selectedConsultant) {
      setConsultantName(selectedConsultant.name)
    }
    else {
      setConsultantName("")
    }
  }, [showModal])

  useEffect(() => {
    if(isCreating){
      bringConsultants()
      setIsCreating(null)
      setShowModal(false)
    }
  }, [isCreating])

  useEffect(() => {
    if(isDeleting){
      bringConsultants()
      setIsDeleting(null)
    }
  }, [isDeleting])

  useEffect(() => {
    if(isEditing){
      bringConsultants()
      setShowModal(false)
      setIsEditing(null)
    }
  }, [isEditing])

  useEffect(() => {
  }, [consultantsList])

  useEffect(() => {
    bringConsultants()
  },[])


  return (
    <DndProvider backend={HTML5Backend}>
      <div>
        <div className={'card settings-card'}>
          <div className='card-header'>
            <h1 className='title'>Consultoras</h1>
          </div>
          <div className='card-body'>
            <div>
              {/*<DragSortingTable*/}
              {/*  columnList={columnList}*/}
              {/*  dataList={consultantsList}*/}
              {/*  setDataList={setConsultantsList}*/}
              {/*  updateFunction={updateOrder}*/}
              {/*/>*/}
              <Table columns={columnList} dataSource={consultantsList} />
            </div>
            <div className='button-add'>
              <Button onClick={() => onChangeState(null)}>Crear nueva consultora</Button>
            </div>
          </div>
        </div>
        {showModal && showConsultantModalList()}
      </div>
    </DndProvider>
  )
}

export default Consultants;